export interface IFonts {
  arial: string;
}

export const fonts: IFonts = {
  arial: 'Arial, sans-serif;',
};
